import useFetchPaymentLinkAssociatedPaymentId from './hooks/useFetchPaymentLinkAssociatedPaymentId';
import PaymentLinkViewPaymentButton from './PaymentLinkViewPaymentButton';
import { jsx as _jsx } from "react/jsx-runtime";
const useGetPaymentLinkChickletSecondaryDisplayLabels = ({
  objectId,
  onPreview,
  hasScope,
  fromObjectId,
  fromObjectTypeId
}) => {
  const {
    associatedPaymentId
  } = useFetchPaymentLinkAssociatedPaymentId(objectId, hasScope || (() => false), fromObjectId || 0, fromObjectTypeId || '');
  return {
    copyDisabled: true,
    additionalPostfixContent: /*#__PURE__*/_jsx(PaymentLinkViewPaymentButton, {
      objectId: objectId,
      onPreview: onPreview,
      hasScope: hasScope || (() => false),
      sourceObjectId: fromObjectId || 0,
      sourceObjectTypeId: fromObjectTypeId || ''
    }),
    hideSecondaryDisplayLabels: !!associatedPaymentId
  };
};
export default useGetPaymentLinkChickletSecondaryDisplayLabels;